import { createSingleAction } from 'store/utils';
import {
    IEmployeeSubmittedSheetsFilters,
    ISheetsEditDetail,
} from 'store/components/employeeSubmittedSheets/employeeSubmittedSheetsModel';

export const SET_EMPLOYEE_SUBMITTED_SHEETS_FILTERS = 'SET_EMPLOYEE_SUBMITTED_SHEETS_FILTERS';

export const setEmployeeSubmittedSheetsFilters = createSingleAction<
Partial<IEmployeeSubmittedSheetsFilters>,
    typeof SET_EMPLOYEE_SUBMITTED_SHEETS_FILTERS
>(
    SET_EMPLOYEE_SUBMITTED_SHEETS_FILTERS,
);

const SET_RESUBMIT_SHEET = 'SET_RESUBMIT_SHEET';

export const setResubmitSheet = createSingleAction<
ISheetsEditDetail | null,
typeof SET_RESUBMIT_SHEET
>(
    SET_RESUBMIT_SHEET,
);
